/* eslint-disable */
import { Box, Card, Grid, styled, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import CurrentSearchResultChart from "./CurrentSearchResulChart";
import AveragePosition from "./AveragePosition";
// import AveragePosition from "./AveragePosition";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .CurrentSearchResult": {
    "& .chartWrapper": {
      width: "100px",
      height: "100px",
    },
    "& .listitemText": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    "& .renderLegend": {
      width: "100%",
      "& ul": {
        "& li": {
          padding: 0,
          borderBottom: `1px solid #e5eaef`,
          "& .litsItemIconBox": {
            minWidth: "35px",
          },
        },
      },
    },
    "& .chartMainWrapperBox": {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
  },
  "& .currentSearchHead": {
    color: theme.palette.text.primary,
    fontWeight: 600,
    // fontSize: "18px",
  },
}));
const chartStyles = {
  width: "100%",
  padding: "10px",
  color: "gray",
  ".title": { marginBottom: "20px" },
  ".chartGrid": { stroke: "rgb(228, 225, 225)" },
  "& .areachartBox": {
    boxShadow: "0px 2px 4px 0px #45C0CB",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: "url('/path/to/your/image.png')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      opacity: 1,
      zIndex: 1,
      backgroundColor: "red",
      width: "100px",
      height: "20px",
    },
  },
};
const data = [
  { name: "Top 3", value: 0, color: "#A6F4C5" },
  { name: "Top 10", value: 0, color: "#FDBA74" },
  { name: "Top 100", value: 0, color: "#FDB44D" },
  { name: "Not Ranking", value: 0, color: "#F87171" },
];
function CurrentSearchResultRankings({ rankingData }) {
  const theme = useTheme();
  const [arrayState, setArrayState] = useState(data);
  useEffect(() => {
    if (rankingData) {
      const { top3, top10, top100, topAbove100 } = rankingData?.rankCounts;
      const createData = [
        { name: "Top 3", value: top3, color: "#A6F4C5" },
        { name: "Top 10", value: top10, color: "#FDBA74" },
        { name: "Top 100", value: top100, color: "#FDB44D" },
        { name: "Not Ranking", value: topAbove100, color: "#F87171" },
      ];
      setArrayState(createData);
    }
  }, [rankingData]);
  return (
    <>
      <BoxWrapper>
        <Card sx={{ border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
          <Typography className="currentSearchHead" component="h2">
            Current Search Result Rankings
          </Typography>

          <Box className="CurrentSearchResult">
            <CurrentSearchResultChart chartData={arrayState}/>
          </Box>
        </Card>
      </BoxWrapper>
    </>
  );
}

export default CurrentSearchResultRankings;
